/**
 * スペース詳細ページのクーポンフローティングバナー（ABテスト: GROWTH-4212）
 * 未ログインユーザーがクーポンを取得した際にlocalStorageに保存されたcouponIdを、
 * ログイン/新規登録成功後にCreatePrivateCoupon mutationで自動紐付けする
 */

const STORAGE_KEY = 'spmPendingCoupon'

const getPendingCouponId = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (parsed.expireSecond <= Date.now() / 1000) {
      localStorage.removeItem(STORAGE_KEY)
      return null
    }
    return parsed.couponId || null
  } catch {
    return null
  }
}

const clearPendingCoupon = () => {
  localStorage.removeItem(STORAGE_KEY)
}

export const applyPendingCoupon = async (graphqlHost, headers) => {
  const couponId = getPendingCouponId()
  if (!couponId) return

  try {
    await fetch(`${graphqlHost}/graphql`, {
      method: 'POST',
      headers: { ...headers, 'Content-Type': 'application/json' },
      body: JSON.stringify({
        query: `mutation CreatePrivateCoupon($input: CreatePrivateCouponInput!) {
          createPrivateCoupon(input: $input) {
            privateCouponId
          }
        }`,
        variables: { input: { couponId } },
      }),
    })
    clearPendingCoupon()
  } catch (e) {
    console.error('Failed to claim pending coupon:', e)
  }
}
